import { ShowFlash, DismissFlash } from 'ng2/shared/flash/store/flash.actions';
import { authenticatedPatientSelector } from '../../selectors/patients-selectors.ts';

module.exports = {
  templateUrl: 'main/components/appointment-details/appointment-details.html',
  controller: class AppointmentDetailsController {

    static $inject = [
      '$ngRedux',
      '$scope',
      '$state',
      '$translate',
      'Appointments',
      'LoadingService',
      'PatientAppContextService',
      'ProductService',
    ];

    constructor(
      $ngRedux,
      $scope,
      $state,
      $translate,
      Appointments,
      LoadingService,
      PatientAppContextService,
      ProductService,
    ) {
      this.$ngRedux = $ngRedux;
      this.$scope = $scope;
      this.$state = $state;
      this.$translate = $translate;
      this.Appointments = Appointments;
      this.LoadingService = LoadingService;
      this.PatientAppContextService = PatientAppContextService;
      this.productService = ProductService;
    }

    $onInit() {
      this.initializeStateConnection();

      // TODO: Use Redux when BOOK-1234 will be merged
      this.patient = this.PatientAppContextService.context.patient;
      this.authenticatedPatient = this.PatientAppContextService.context.authenticatedPatient;
      this.shortTermReminderOffsetsValues = { no_short_term_reminder: null, one_hour: 1, two_hours: 2, three_hours: 3 };
      this.longTermReminderOffsetsValues = { no_long_term_reminder: null, one_day: 24, two_days: 48, three_days: 72 };

      this.Appointments.get({ id: +this.$state.params.appointmentId }, (appointment) => {
          // Bring the availability start/end times down to the appointment level for convenience in the template
        appointment.startTime = appointment.availability.startTime;
        appointment.endTime = appointment.availability.endTime;

          // Apply a specific format for this screen to the date of the appointment
        appointment.formattedDate = moment(appointment.startTime).format(this.$translate.instant('date_format.dayname_day_month_and_year'));

        this.appointment = appointment;
        this.reason = appointment.availability.reason;

        this.shortTermReminder = this.getShortTermReminderHours();
        this.longTermReminder = this.getLongTermReminderHours();

        this.$ngRedux.dispatch(new ShowFlash({ name: 'update-profile' }));
        this.LoadingService.hide();
      });
    }

    initializeStateConnection() {
      this.$scope.$on('$destroy', this.$ngRedux.connect(state => ({
        group: state.group,
        authenticatedPatient: authenticatedPatientSelector(state),
      }))(this));
    }

    getShortTermReminderHours() {
      if (this.reason && this.reason.disableNotifications) {
        return undefined;
      }
      if (this.reason && this.reason.shortTermReminderOffset) {
        return this.shortTermReminderOffsetsValues[this.reason.shortTermReminderOffset];
      }
      if (this.group.shortTermReminderOffset && this.group.shortTermReminderOffset) {
        return this.shortTermReminderOffsetsValues[this.group.shortTermReminderOffset];
      }
      return undefined;
    }

    getLongTermReminderHours() {
      if (this.reason && this.reason.disableNotifications) {
        return undefined;
      }
      if (this.reason && this.reason.longTermReminderOffset && this.reason.longTermReminderOffset) {
        return this.longTermReminderOffsetsValues[this.reason.longTermReminderOffset];
      }
      if (this.group.longTermReminderOffset && this.group.longTermReminderOffset) {
        return this.longTermReminderOffsetsValues[this.group.longTermReminderOffset];
      }
      return undefined;
    }

    getReminderText() {
      const shortTermReminder = this.getShortTermReminderHours();
      const longTermReminder = this.getLongTermReminderHours();

      const notificationPreference = this.authenticatedPatient.subscription.notificationPreference;
      const reminders = notificationPreference === 'email' ? this.authenticatedPatient.email : this.authenticatedPatient.profile.contactMethods[0].number;

      if (shortTermReminder && longTermReminder) {
        if (shortTermReminder > 1) {
          return this.$translate.instant('appointment.reminder_notice_text_several_hours', { type: notificationPreference, reminders, longTermTime: longTermReminder, shortTermTime: shortTermReminder });
        }
        return this.$translate.instant('appointment.reminder_notice_text_one_hour', { type: notificationPreference, reminders, longTermTime: longTermReminder, shortTermTime: shortTermReminder });
      } else if (this.shortTermReminder || this.longTermReminder) {
        if (this.shortTermReminder && this.shortTermReminder > 1) {
          return this.$translate.instant('appointment.reminder_notice_text_one_reminder_several_hours', { type: notificationPreference, reminders, longTermTime: longTermReminder, shortTermTime: shortTermReminder });
        }
        return this.$translate.instant('appointment.reminder_notice_text_one_reminder_one_hour', { type: notificationPreference, reminders, longTermTime: longTermReminder, shortTermTime: shortTermReminder });
      }
      return '';
    }

    showReminderText() {
      return this.getLongTermReminderHours() || this.getShortTermReminderHours();
    }

    editReminders() {
      this.$ngRedux.dispatch(new DismissFlash());
      this.$state.go('patients.id.update.appointment-reminders');
    }

    get hasManitobaProduct() {
      return this.productService.isAvailable('MANITOBA_BOOKING');
    }
  },
};



// WEBPACK FOOTER //
// ./main/components/appointment-details/appointment-details.js